(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('status-alumno-plan-de-estudios', {
            parent: 'entity',
            url: '/status-alumno-plan-de-estudios',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'StatusAlumnoPlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios.html',
                    controller: 'StatusAlumnoPlanDeEstudiosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('status-alumno-plan-de-estudios-detail', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/status-alumno-plan-de-estudios/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'StatusAlumnoPlanDeEstudios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-detail.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'StatusAlumnoPlanDeEstudios', function($stateParams, StatusAlumnoPlanDeEstudios) {
                    return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'status-alumno-plan-de-estudios',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('status-alumno-plan-de-estudios-detail.edit', {
            parent: 'status-alumno-plan-de-estudios-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatusAlumnoPlanDeEstudios', function(StatusAlumnoPlanDeEstudios) {
                            return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('status-alumno-plan-de-estudios.new', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('status-alumno-plan-de-estudios', null, { reload: 'status-alumno-plan-de-estudios' });
                }, function() {
                    $state.go('status-alumno-plan-de-estudios');
                });
            }]
        })
        .state('status-alumno-plan-de-estudios.edit', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatusAlumnoPlanDeEstudios', function(StatusAlumnoPlanDeEstudios) {
                            return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('status-alumno-plan-de-estudios', null, { reload: 'status-alumno-plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('status-alumno-plan-de-estudios.delete', {
            parent: 'status-alumno-plan-de-estudios',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/status-alumno-plan-de-estudios/status-alumno-plan-de-estudios-delete-dialog.html',
                    controller: 'StatusAlumnoPlanDeEstudiosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatusAlumnoPlanDeEstudios', function(StatusAlumnoPlanDeEstudios) {
                            return StatusAlumnoPlanDeEstudios.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('status-alumno-plan-de-estudios', null, { reload: 'status-alumno-plan-de-estudios' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
